import Box from '@mui/material/Box'
import Typography from '@mui/material/Typography'
import moment from 'moment'
import React from 'react'

import useGetBilling from '@/app/module/dashboard/hooks/use-get-billing'
import { numberWithCommas } from '@/app/service/util/format'

type Props = {}

const PeriodUsage: React.FC<Props> = () => {
  const { data } = useGetBilling()

  const smsSent = numberWithCommas(data?.smsStats?.totalEgress || 0)
  const smsReceived = numberWithCommas(data?.smsStats?.totalIngress || 0)
  const voiceSent = numberWithCommas(data?.voiceStats?.totalEgress || 0)
  const voiceReceived = numberWithCommas(data?.voiceStats?.totalIngress || 0)
  const whatsappSent = numberWithCommas(data?.whatsappStats?.totalEgress || 0)
  const whatsappReceived = numberWithCommas(data?.whatsappStats?.totalIngress || 0)

  return (
    <Box display="flex" flexDirection="column" gap={0.5}>
      <Typography color="textSecondary" variant="subtitle1">
        Usage <strong>({moment().format('MMMM YYYY')})</strong>
      </Typography>
      <Typography variant="body1">
        SMS: {smsSent} sent / {smsReceived} received
      </Typography>
      <Typography variant="body1">
        Calls: {voiceSent} sent / {voiceReceived} received
      </Typography>
      <Typography variant="body1">
        WhatsApp: {whatsappSent} sent / {whatsappReceived} received
      </Typography>
    </Box>
  )
}

export default PeriodUsage
